import { isEmpty } from "lodash";
import { createSelector } from "reselect";

import { TIFCollectionItem } from "@app/types/insider";

import { schema } from "../schema";
import { EUIIMainSOT } from "../schema/uiInvoiceMain.def";
import { AppState } from "../xstore";

function createParameterSelector(selector: any) {
  return (_: AppState, params: any) => selector(params);
}
// const selectors = repo_collected_ifiscal.getSelectors(
//   (s: AppState) => s[REPO_COLLECTED_IFISCAL]
// );

// const selectAllCollectionsFetchedArr = selectors.selectTableAsList;

const getByFFID = createParameterSelector(
  (params: { ffid: number }) => params.ffid
);

export const selectCollectionByFFID = createSelector(
  schema.invoiceCollection.selectTableAsList,
  getByFFID,
  (list: TIFCollectionItem[], ffid: number) => {
    return (list || []).filter((item) => item.FF_ID === ffid);
  }
);

export const selectCurentInvoiceForPayments = createSelector(
  schema.uiInvoiceOverall.select,
  schema.uiSpvMain.select,
  schema.uiInvoiceCurrent.select,
  schema.invoiceFiscal.selectTable,
  schema.invoiceIssuer.selectTable,
  (invOverall, upSpv, uiInvAll, ivf, ivIssuer) => {
    const crtInvoice = {
      FF_ID: -1,
      ABR: "",
      MONEDA_FF: "RON",
      REST_DE_INCASAT: 0,
    };
    if (invOverall.mainSOT === EUIIMainSOT.SPV_OVERALL) {
      if (isEmpty(upSpv.currentRecord)) {
        return crtInvoice;
      }
      const { FF_ID } = upSpv.currentRecord;
      if ((FF_ID || 0) < 1) {
        return crtInvoice;
      }
      const key = `${ivIssuer[invOverall.selectedCIF]?.ABR}/${FF_ID}`;
      const rec = ivf[key];
      if (rec) {
        return rec;
      } else {
        return crtInvoice;
      }
    } else {
      if (invOverall.mainSOT === EUIIMainSOT.FACTURI_FISCALE_EMISE) {
        return isEmpty(uiInvAll.currentRecord)
          ? crtInvoice
          : uiInvAll.currentRecord;
      }
    }
  }
);

export const selectInvoicePayments = createSelector(
  schema.uiInvoiceOverall.select,
  schema.uiSpvMain.select,
  schema.uiInvoiceCurrent.select,
  schema.invoiceCollection.selectTableAsList,
  (invOverall, upSpv, uiInvAll, list) => {
    let crtInvoice = -1;
    if (invOverall.mainSOT === EUIIMainSOT.SPV_OVERALL) {
      crtInvoice = upSpv.currentRecord?.FF_ID ?? -1;
    } else {
      if (invOverall.mainSOT === EUIIMainSOT.FACTURI_FISCALE_EMISE) {
        crtInvoice = uiInvAll.currentRecord?.FF_ID ?? -1;
      }
    }
    return list.filter((item) => item.FF_ID === crtInvoice);
  }
);
